import React, { useState, useEffect } from 'react';
import { apiFetch } from './api';
import ProjektDetail from './projektDetail';

const Abrechnung = ({ user }) => {
  const [projekte, setProjekte] = useState([]);
  const [loading, setLoading] = useState(true);
  const [offenesProjekt, setOffenesProjekt] = useState(null);
  const [popup, setPopup] = useState(null);
  const [notiz, setNotiz] = useState('');

  const lade = async () => {
    setLoading(true);
    const res = await apiFetch('/abrechnung/offen');
    if (!res) return;
    const data = await res.json();
    setProjekte(Array.isArray(data) ? data : []);
    setLoading(false);
  };

  useEffect(() => { lade(); }, []);

  const popupOeffnen = (p) => {
    setPopup(p);
    setNotiz('');
  };

  const abrechnen = async () => {
    await apiFetch(`/projekte/${popup.id}/abrechnen`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ abrechnungs_notiz: notiz })
    });
    setPopup(null);
    lade();
  };

  const typLabel = (typ) => {
    if (typ === 'produktion') return 'Produktion';
    if (typ === 'format') return 'Format';
    if (typ === 'backoffice') return 'Backoffice';
    return typ;
  };

  const formatDeadline = (dl) => {
    if (!dl) return '—';
    const d = new Date(dl);
    return `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()}`;
  };

  if (offenesProjekt) {
    return <ProjektDetail projektId={offenesProjekt} onZurueck={() => { setOffenesProjekt(null); lade(); }} />;
  }

  return (
    <div style={{ padding: '40px' }}>
      <div style={{ marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1a1a1a', margin: '0 0 6px 0', letterSpacing: '-0.5px' }}>
          Abrechnung
        </h2>
        <p style={{ fontSize: '14px', color: '#9b9b9b', margin: 0 }}>
          Abgeschlossene Projekte die noch nicht abgerechnet wurden
        </p>
      </div>

      {loading ? (
        <p style={{ fontSize: '14px', color: '#c4c4c4' }}>Lädt...</p>
      ) : projekte.length === 0 ? (
        <div style={{
          backgroundColor: '#ffffff', border: '1px solid #efefef', borderRadius: '10px',
          padding: '40px', textAlign: 'center'
        }}>
          <p style={{ fontSize: '28px', margin: '0 0 12px 0' }}>✓</p>
          <p style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', margin: '0 0 6px 0' }}>Alles abgerechnet</p>
          <p style={{ fontSize: '14px', color: '#9b9b9b', margin: 0 }}>Keine offenen Abrechnungen.</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {projekte.map(p => (
            <div key={p.id} style={{
              backgroundColor: '#ffffff', border: '1px solid #efefef', borderRadius: '10px',
              padding: '16px 20px', display: 'flex', alignItems: 'center', gap: '16px',
              borderLeft: p.mutter_farbe ? `4px solid ${p.mutter_farbe}` : '4px solid #e8e8e8'
            }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{
                  fontSize: '14px', fontWeight: '600', color: '#1a1a1a',
                  margin: '0 0 3px 0', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
                }}>
                  {p.name}
                </p>
                <p style={{ fontSize: '12px', color: '#9b9b9b', margin: 0 }}>
                  {typLabel(p.parent_typ)} · {p.mutter_name}
                  {p.deadline ? ` · Deadline ${formatDeadline(p.deadline)}` : ''}
                </p>
              </div>
              <button onClick={() => setOffenesProjekt(p.id)} style={{
                padding: '5px 12px', backgroundColor: 'transparent', border: '1px solid #e8e8e8',
                borderRadius: '6px', fontSize: '12px', color: '#6b6b6b', cursor: 'pointer', flexShrink: 0
              }}>Öffnen</button>
              <button onClick={() => popupOeffnen(p)} style={{
                padding: '5px 14px', backgroundColor: '#1a1a1a', color: '#fff', border: 'none',
                borderRadius: '6px', fontSize: '12px', fontWeight: '600', cursor: 'pointer', flexShrink: 0
              }}>Abrechnung abschließen</button>
            </div>
          ))}
        </div>
      )}

      {popup && (
        <div onClick={() => setPopup(null)} style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.35)', display: 'flex',
          alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px'
        }}>
          <div onClick={(e) => e.stopPropagation()} style={{
            backgroundColor: '#ffffff', borderRadius: '14px', width: '100%', maxWidth: '460px',
            padding: '32px', boxShadow: '0 12px 48px rgba(0,0,0,0.18)',
            borderTop: popup.mutter_farbe ? `4px solid ${popup.mutter_farbe}` : '4px solid #e8e8e8'
          }}>
            <p style={{
              fontSize: '11px', fontWeight: '500', color: popup.mutter_farbe || '#9b9b9b',
              textTransform: 'uppercase', letterSpacing: '0.5px', margin: '0 0 4px 0'
            }}>
              {popup.mutter_name}
            </p>
            <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#1a1a1a', margin: '0 0 6px 0', letterSpacing: '-0.3px' }}>
              {popup.name}
            </h3>
            <p style={{ fontSize: '13px', color: '#9b9b9b', margin: '0 0 24px 0' }}>
              Abrechnung für dieses Projekt abschließen
            </p>

            <div style={{ marginBottom: '24px' }}>
              <label style={{
                display: 'block', fontSize: '11px', fontWeight: '500', color: '#6b6b6b',
                marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px'
              }}>Notiz (optional)</label>
              <textarea
                value={notiz}
                onChange={(e) => setNotiz(e.target.value)}
                placeholder="z.B. Rechnung Nr. 2024-047 gestellt, Betrag 2.400 €..."
                rows={4}
                style={{
                  width: '100%', padding: '10px 12px', fontSize: '13px',
                  border: '1px solid #e8e8e8', borderRadius: '8px', outline: 'none',
                  resize: 'vertical', boxSizing: 'border-box', fontFamily: 'inherit',
                  color: '#1a1a1a', lineHeight: '1.5'
                }}
              />
            </div>

            <div style={{ display: 'flex', gap: '8px' }}>
              <button onClick={abrechnen} style={{
                padding: '10px 20px', backgroundColor: '#1a1a1a', color: '#fff', border: 'none',
                borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer'
              }}>✓ Abrechnung abschließen</button>
              <button onClick={() => setPopup(null)} style={{
                padding: '10px 20px', backgroundColor: 'transparent', color: '#6b6b6b',
                border: '1px solid #e8e8e8', borderRadius: '8px', fontSize: '13px', cursor: 'pointer'
              }}>Abbrechen</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Abrechnung;